import React from 'react';

export class ErrorBoundary extends React.Component<
  { children: React.ReactNode },
  { hasError: boolean }
> {
  constructor(props: $TSFixMe) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(_error: $TSFixMe) {
    return { hasError: true };
  }

  render() {
    if (this.state.hasError) {
      return null;
    }

    return this.props.children;
  }
}
